import ReactTable from "../../components/react-table/contabilidad-maintenance";

function MaintenanceContabilidad() {
  return (
    <div>
      <ReactTable contextmenu="mantiene" />
    </div>
  );
}

export default MaintenanceContabilidad;
